import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import { all_routes } from "../../router/all_routes";
import CaseComponent from "./CaseComponent";

const CaseSummary = () => {
  const { isAuthenticated } = useAuth();

  return isAuthenticated ? (
    <CaseComponent />
  ) : (
    <Navigate to={all_routes.login} replace />
  );
};

export default CaseSummary;
